var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 9.5,
    stroke: "#5921F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 14.625L21.84 13.8572C21.2804 13.2694 20.6071 12.8017 19.8609 12.4824C19.1148 12.1631 18.3116 11.999 17.5 12C14.1875 12 11.5 14.6875 11.5 18C11.5 21.3125 14.1875 24 17.5 24C18.7409 23.9999 19.9514 23.6152 20.9647 22.8989C21.978 22.1826 22.7444 21.1698 23.1584 20",
    stroke: "#5921F2",
    strokeWidth: 1.33,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4998 13.0405V16.4962C24.4998 16.6288 24.4471 16.7559 24.3533 16.8497C24.2596 16.9435 24.1324 16.9962 23.9998 16.9962H20.5442C20.0985 16.9962 19.8754 16.4577 20.1904 16.1427L23.6464 12.6868C23.9614 12.3712 24.4998 12.5949 24.4998 13.0405Z",
    fill: "#5921F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReUpload);
export default __webpack_public_path__ + "static/media/ReUpload.a87b1f3a4fb59ab09dc29e168c31ea17.svg";
export { ForwardRef as ReactComponent };